import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LogManifestService } from "../../../services/logmanifest.service";
import { LogManifest } from "../../../models/logManifest";
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Methods } from '../../methods';
import { ChatLog } from "../../../models/chatLog";
import { ChatLogService } from '../../../services/chatlog.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-pi-comments',
  templateUrl: './pi-comments.component.html',
  styleUrls: ['./pi-comments.component.css'],
  providers: [ LogManifestService, ChatLogService ]
})
export class PiCommentsComponent implements OnInit {

  myWebSocket: WebSocketSubject<any> = webSocket(
    "wss://www.greenteksolutions.com/myws"
  );

  @Input() id_phather;
  @Input() id_po;
  @Input() po;
  @Input() type;

  @Output() totalchats: EventEmitter<number>;

  public chats: Array<LogManifest> = [];
  public chatsWeights: Array<ChatLog>;

  public identity;
  public token;
  public newchatmsg;
  public loading = false;
  public saving = false;
  public numberNotifications;
  public notificationsData;
  public jsonChatLog;
  public itemEditar;
  public idChat;
  public numberChats;

  constructor(private _logManifestService: LogManifestService, private _chatLogService: ChatLogService,) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));
    this.totalchats = new EventEmitter();
  }

  ngOnInit() {
    console.log(this.identity);
    this.getChat();
  }

  sendMessage(message: string) {
    message = message.trim();
    if (message.length > 0) {
      //this.messages.push(message);
      this.newchatmsg = message;
      this.sendChat();
    }
  }

  sendChat() {
    this.loading = true;

    let enviar;
    enviar = {
      message: this.newchatmsg,
      pi_id: this.id_phather,
      type: this.type
    };

    this._logManifestService.create(this.token, enviar).subscribe(
      (response) => {
        this.loading = false;
        if (response.status === "success") {
          console.log(response.data);

          /*this.chats.push(response.data);

          this.numberChats = this.numberChats + 1;

          this.totalchats.emit(this.numberChats);*/

          this.getChat();

          this.myWebSocket.next({
            notify: "1",
            data: this.id_phather,
            type: "NEW-LOG",
            token: this.token,
            action: response.data.rep.name + " " + response.data.rep.surname, // NEW ó UPDATE ó DELETE
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.myWebSocket.next({
            notify: "1",
            data: this.id_phather,
            type: "NOTETAGGED",
            token: this.token,
            action: "NEW", // NEW ó UPDATE ó DELETE
            toDestiny: "USERS",
            toData: this.newchatmsg,
            element: this.id_po,
            texto: this.po,
          });

          this.myWebSocket.asObservable().subscribe(
            (msg) => {
              let msgCoded;
              msgCoded = JSON.stringify(msg);
              console.log("message received: " + msgCoded);
              this.numberNotifications = msg.numberNotifications;
              this.notificationsData = msg.data;
            },
            // Called whenever there is a message from the server
            (err) => console.log(err),
            // Called if WebSocket API signals some kind of error
            () => console.log("complete")
            // Called when connection is closed (for whatever reason)
          );

          this.newchatmsg = "";
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  deleteChat(id) {
    this.idChat = id;

    if (confirm("Are you sure you want to delete this chat?")) {
      this.saving = true;
      this._logManifestService.remove(this.token, this.idChat).subscribe(
        (response) => {
          if (response.status != "success") {
            if (response.longmsg) {
              this.showSwal("error", response.msg, response.longmsg);
            } else {
              this.showSwal("error", "ERROR!", response.msg);
            }
          } else {
            this.showSwal(
              "success",
              "Chat removed!",
              "The chat has been removed successfully"
            );
            this.getChat();
          }
          this.saving = false;
        },
        (error) => {
          console.log(<any>error);
          this.saving = false;
          this.showSwal("error");
        }
      );
    }
  }

  getChat() {
    this._logManifestService.getChat(this.token, this.id_phather).subscribe(
      (response) => {
        if (response.status === "success") {
          // Filtrar los chats por tipo
          this.chats = response.data.filter((chat: any) => chat.type === this.type);
          
          console.log(this.chats);
          this.numberChats = response.data.length;
          this.totalchats.emit(this.numberChats);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
      
        title: title,
        text: message,
        buttonsStyling: false,
        
 customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    } else if (type === "error") {
      swal.fire({
     
        title: "ERROR!",
        text: "An error has ocurred.",
        buttonsStyling: false,
        
 customClass:{
    confirmButton: 'btn btn-success'
            },
      });
    }
  }

}
